// edit-input.jsx
import React from 'react';
import { EditIconButton, InputWrapper, StyledInput } from './edit-input.styled';
import { useEditInput } from './edit-input.hooks';

export interface EditInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const EditInput: React.FC<EditInputProps> = (props) => {
  const { placeholder = '', value = '', ...rest } = props;

  const { inputRef, handleIconClick } = useEditInput({ placeholder, value });

  return (
    <InputWrapper>
      <StyledInput ref={inputRef} type="text" placeholder={placeholder} value={value} {...rest} />

      <EditIconButton type="button" onClick={handleIconClick}>
        <div
          style={{
            height: '100%',
            width: '100%',
            background: '   #23252A',
            paddingLeft: '4px',
          }}
        >
        </div>
      </EditIconButton>
    </InputWrapper>
  );
};
